/** Locked stage width/height. CSS aspect-ratio and camera.aspect both use this. */
export const STAGE_ASPECT = 16 / 9
/** Overlay design width. Lower = larger title/copy after stage scale. */
export const STAGE_DESIGN_WIDTH = 1920
export const STAGE_DESIGN_HEIGHT = STAGE_DESIGN_WIDTH / STAGE_ASPECT
export const STAGE_REM = 16
